import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const TotalStudentDisplay = ({ formik, translationPrefix }) => {
  const { t } = useTranslation();

  const [totalStudentsSelected, setTotalStudentsSelected] = useState({
    thu: 0,
    fri: 0,
    sat: 0,
  });

  useEffect(() => {
    let tempThu = 0;
    let tempFri = 0;
    let tempSat = 0;

    formik.values?.classes?.forEach((classDetail) => {
      if (classDetail.visitDay === 'thu') {
        tempThu += parseInt(classDetail.numberOfStudents) || 0;
      } else if (classDetail.visitDay === 'fri') {
        tempFri += parseInt(classDetail.numberOfStudents) || 0;
      } else if (classDetail.visitDay === 'sat') {
        tempSat += parseInt(classDetail.numberOfStudents) || 0;
      }
    });

    setTotalStudentsSelected({
      thu: tempThu,
      fri: tempFri,
      sat: tempSat,
    });
  }, [formik.values?.classes]);

  return (
    <div className="w-full mt-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="col-span-1 grid grid-cols-3 gap-4 items-center">
          <div
            className="font-semibold text-sm text-gray-10 col-span-2"
            dangerouslySetInnerHTML={{ __html: t(`${translationPrefix}.totalStudents.thu`) }}
          />
          <div className="bg-lightBlue-20 p-4 rounded-lg text-center text-gray-10/60 col-span-1">
            {totalStudentsSelected.thu}
          </div>
        </div>

        <div className="col-span-1 grid grid-cols-3 gap-4 items-center">
          <div
            className="font-semibold text-sm text-gray-10 col-span-2"
            dangerouslySetInnerHTML={{ __html: t(`${translationPrefix}.totalStudents.fri`) }}
          />
          <div className="bg-lightBlue-20 p-4 rounded-lg text-center text-gray-10/60 col-span-1">
            {totalStudentsSelected.fri}
          </div>
        </div>

        <div className="col-span-1 grid grid-cols-3 gap-4 items-center">
          <div
            className="font-semibold text-sm text-gray-10 col-span-2"
            dangerouslySetInnerHTML={{ __html: t(`${translationPrefix}.totalStudents.sat`) }}
          />
          <div className="bg-lightBlue-20 p-4 rounded-lg text-center text-gray-10/60 col-span-1">
            {totalStudentsSelected.sat}
          </div>
        </div>

        <div className="col-span-1 grid grid-cols-3 gap-4 items-center">
          <div
            className="font-semibold text-sm text-gray-10 col-span-2"
            dangerouslySetInnerHTML={{ __html: t(`${translationPrefix}.totalStudents.total`) }}
          />
          <div className="bg-lightBlue-20 p-4 rounded-lg text-center text-gray-10/60 col-span-1">
            {totalStudentsSelected.thu + totalStudentsSelected.fri + totalStudentsSelected.sat}
          </div>
        </div>
      </div>

      <div
        className="mt-8 text-center"
        dangerouslySetInnerHTML={{ __html: t(`${translationPrefix}.totalStudents.warning`) }}
      />
    </div>
  );
};

export default TotalStudentDisplay;
